// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type Discovery = {
  mode: "teaser" | "hidden" | "contact";
  teaserCopy?: string | undefined;
  learnMoreUrl?: string | null | undefined;
  upsellPlanSlug?: string | null | undefined;
};
export const DiscoverySchema = z.object({
  mode: z.enum(["teaser", "hidden", "contact"] as const),
  teaserCopy: z.string().optional(),
  learnMoreUrl: z.string().nullable().optional(),
  upsellPlanSlug: z.string().nullable().optional(),
}).strict();

export type FeatureState = {
  state: "on" | "off" | "locked";
  reason?: string | undefined;
  discovery?: Discovery | undefined;
};
export const FeatureStateSchema = z.object({
  state: z.enum(["on", "off", "locked"] as const),
  reason: z.string().optional(),
  discovery: DiscoverySchema.optional(),
}).strict();

export type OrgBrandingOverlay = {
  logoUrl: string | null;
  primaryColor: string | null;
  primaryForeground: string | null;
  accentColor: string | null;
  accentForeground: string | null;
  faviconUrl: string | null;
  font: "outfit" | "system" | "serif" | null;
};
export const OrgBrandingOverlaySchema = z.object({
  logoUrl: z.string().nullable(),
  primaryColor: z.string().nullable(),
  primaryForeground: z.string().nullable(),
  accentColor: z.string().nullable(),
  accentForeground: z.string().nullable(),
  faviconUrl: z.string().nullable(),
  font: z.enum(["outfit", "system", "serif"] as const).nullable(),
}).strict();

export type CapabilityDocument = {
  permissions: Array<string>;
  features: Record<string, FeatureState>;
  permVersion: number;
  flagVersion: number;
  platformRole: string | null;
  orgKind: string | null;
  orgName: string | null;
  roleNames: Array<string>;
  branding: OrgBrandingOverlay;
};
export const CapabilityDocumentSchema = z.object({
  permissions: z.array(z.string()),
  features: z.record(FeatureStateSchema),
  permVersion: z.number(),
  flagVersion: z.number(),
  platformRole: z.string().nullable(),
  orgKind: z.string().nullable(),
  orgName: z.string().nullable(),
  roleNames: z.array(z.string()),
  branding: OrgBrandingOverlaySchema,
}).strict();

export type AgentCallQuota = {
  metered: boolean;
  metric: "agentCallsPerMonth";
  used: number | null;
  limit: number | null;
  unlimited: boolean;
  period: {
  start: string | null;
  end: string | null;
} | null;
};
export const AgentCallQuotaSchema = z.object({
  metered: z.boolean(),
  metric: z.literal("agentCallsPerMonth"),
  used: z.number().nullable(),
  limit: z.number().nullable(),
  unlimited: z.boolean(),
  period: z.object({
    start: z.string().nullable(),
    end: z.string().nullable(),
  }).nullable(),
}).strict();

export type GetCapabilitiesResponse = CapabilityDocument;

export async function getCapabilities(): Promise<GetCapabilitiesResponse> {
  const response = await api.get<GetCapabilitiesResponse>(`/me/capabilities`);
  return response.data;
}

export type ConsumeAgentCallResponse = AgentCallQuota;

export async function consumeAgentCall(): Promise<ConsumeAgentCallResponse> {
  const response = await api.post<ConsumeAgentCallResponse>(`/me/agent-calls/consume`);
  return response.data;
}

export const meKeys = {
  all: ["me"] as const,
  lists: () => [...meKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...meKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...meKeys.all, 'detail'] as const,
  detail: (id: string) => [...meKeys.details(), id] as const,
};
